<template>
  <div>
    <Navigation v-if="!scrollHeaderVisible" />

    <div class="loader" v-images-loaded="onImageLoad">
      <template v-if="project">
        <img :src="project.image" />
        <template v-for="block in project.aboutBlocks">
          <img v-if="block.type == 'image'" :src="block.content.url" />
        </template>
      </template>
    </div>
    <a @click="onFixedArrowClick" class="fixed-arrow"></a>
    <div
      @click.prevent="scrollToTop"
      :class="`scroll-header fixed-header ${
        scrollHeaderVisible ? 'isVisible' : ''
      } ${isScrollingDown ? 'isHiddenByScroll' : ''}`"
    >
      <div class="scroll-header__title" v-if="project">{{ project.title }}</div>
    </div>
    <!-- <router-link
            :class="`page-cursor a-link ${isScrollingDown ? 'isHiddenByScroll' : ''}`"
            :to="{ name: 'projects', params: { activeSection: 'all' } }"
            :event="''"
            @click.native.prevent="onFollowLink( { name: 'projects', params: { activeSection: 'all' } } )"
        >
            /&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('projects_title') }}
        </router-link> -->
    <div class="progress">
      <div class="progress__bar" ref="progressBar"></div>
    </div>
    <div class="container">
      <div class="container__center">
        <div class="project" v-if="project">
          <div
            class="project__preview"
            :style="`background-image: url(${project.image})`"
          >
            <div class="project__preview-content">
              <div class="project__type">
                <div class="wrapper">{{ project.type }}</div>
              </div>
              <div class="project__title" ref="projectTitle">
                <div class="wrapper">{{ project.title }}</div>
              </div>
            </div>
          </div>
          <div class="project__top" ref="projectTop">
            <div class="project-blocks _short">
              <div class="wrapper">
                <!-- <div class="project-blocks__title">{{ $t('project_short') }}</div> -->
                <div class="project-blocks__list">
                  <div
                    class="project-blocks__item"
                    v-if="project.short.location"
                  >
                    <div class="project-blocks__block-title">
                      {{ $t("project_location") }}
                    </div>
                    <div class="project-blocks__block-desc">
                      {{ project.short.location }}
                    </div>
                  </div>
                  <div
                    class="project-blocks__item"
                    v-if="project.short.building"
                  >
                    <div class="project-blocks__block-title">
                      {{ $t("project_building") }}
                    </div>
                    <div class="project-blocks__block-desc">
                      {{ project.short.building }}
                    </div>
                  </div>
                  <div class="project-blocks__item" v-if="project.short.area">
                    <div class="project-blocks__block-title">
                      {{ $t("project_size") }}
                    </div>
                    <div class="project-blocks__block-desc">
                      {{ project.short.area }}
                    </div>
                  </div>
                  <div class="project-blocks__item" v-if="project.short.time">
                    <div class="project-blocks__block-title">
                      {{ $t("project_work_period") }}
                    </div>
                    <div class="project-blocks__block-desc">
                      {{ project.short.time }}
                    </div>
                  </div>
                  <div class="project-blocks__item" v-if="project.short.inside">
                    <div class="project-blocks__block-title">
                      {{ $t("project_inside") }}
                    </div>
                    <div class="project-blocks__block-desc">
                      {{ project.short.inside }}
                    </div>
                  </div>
                  <div class="project-blocks__item" v-if="project.short.opened">
                    <div class="project-blocks__block-title">
                      {{ $t("project_release") }}
                    </div>
                    <div class="project-blocks__block-desc">
                      {{ project.short.opened }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="project__body">
            <div class="wrapper">
              <div class="project__top-info">
                <div class="top__right">
                  <div class="project__top-info">
                    {{ project.shortDescription }}
                  </div>
                </div>
              </div>
            </div>

            <template v-for="(block, ind) in project.aboutBlocks">

              <!-- Horizontal type -->
              <div class="project__text" v-if="block.type == 'text'" :key="block.content.text">
                <div class="wrapper">
                  <div class="project__text-wrapper" :class="{ 'grey__block': ind == 0}">
                    <div class="">{{ block.content.text }}</div>
                    <div class="">{{ block.content.description }}</div>
                  </div>
                </div>
              </div>

              <!-- Vertical type -->
              <div class="project__text-big" v-if="block.type == 'textBig'" :key="block.content.text">
                <div class="wrapper">
                  <div class="project__body__top" :class="{ 'grey__block': ind == 0}">
                    <div class="top__right">
                      <div class="project__top-description">
                        {{ block.content.text }}
                      </div>
                      <div class="project__top__text" v-if="block.content.description">
                        {{ block.content.description }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                :class="`project__image --placement-${block.content.placement}`"
                v-if="block.type == 'image'"
                :key="block.content.url"
              >
                <img :src="block.content.url" />
                <div class="project__image-label" v-if="block.content.label">
                  <div class="wrapper">
                    {{ block.content.label }}
                  </div>
                </div>
              </div>

              <!-- к :class="`project__images-block`" добавлем right, если надо справа -->
              <div
                :class="`project__images-block --placement-${block.content.placement || 'center'}`"
                v-if="block.type == 'two_images'"
                :key="block.content.url_1 + block.content.url_2"
              >
                <div class="project__images-wrapper">
                  <img :src="block.content.url_1" />
                  <img :src="block.content.url_2" />
                </div>
                <div class="project__image-label" v-if="block.content.label">
                  <div class="wrapper">
                    {{ block.content.label }}
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="project__bottom">
            <div class="wrapper">
              <div class="project__bottom-inner">
                <!-- <div
                  class="project-blocks"
                  v-if="project.team && project.team.length"
                >
                  <div class="project-blocks__title">
                    {{ $t("project_team") }}
                  </div>
                  <div class="project-blocks__list">
                    <div
                      class="project-blocks__item"
                      v-for="member in project.team"
                    >
                      <div class="project-blocks__block-name">
                        {{ member.title }}
                      </div>
                      <div class="project-blocks__block-value">
                        {{ member.desc }}
                      </div>
                    </div>
                  </div>
                </div> -->
                <div
                  class="project-blocks"
                  v-if="project.publications && project.publications.length"
                >
                  <div class="project-blocks__title">
                    {{ $t("project_publications") }}
                  </div>
                  <div class="project-blocks__list _mobile-rows">
                    <a
                      :class="`project-blocks__item ${
                        publication.link ? '_link' : ''
                      } `"
                      v-for="publication in project.publications"
                      :target="publication.link ? '_blank' : ''"
                      :href="publication.link ? publication.link : '#'"
                      @click="publication.link ? '' : $event.preventDefault()"
                    >
                      <div class="project-blocks__block-name">
                        {{ publication.title }}
                      </div>
                      <div class="project-blocks__block-value">
                        {{ publication.desc }}
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  class="project-blocks"
                  v-if="project.awards && project.awards.length"
                >
                  <div class="project-blocks__title">
                    {{ $t("project_awards") }}
                  </div>
                  <div class="project-blocks__list _mobile-rows">
                    <div
                      class="project-blocks__item"
                      v-for="award in project.awards"
                    >
                      <div class="project-blocks__block-name">
                        {{ award.title }}
                      </div>
                      <div class="project-blocks__block-value">
                        {{ award.desc }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a
            v-if="nextProject"
            @click.prevent="onChangeProject(nextProject.slug)"
            class="project__next"
            :href="
              $router.resolve({
                name: 'project',
                params: { projectSlug: nextProject.slug },
              }).href
            "
          >
            <div
              class="project__next-image"
              :style="`background-image: url(${nextProject.image})`"
            ></div>
            <div class="project__next-content">
              <div class="wrapper">
                <div class="project__next-label">{{ $t("project_next") }}</div>
                <div class="project__next-title">
                  {{ nextProject.title }}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenLite } from "gsap";
import { globalMixin, scrollMixin, pageArrowMixin } from "../mixins";
import Vue from "vue";
import Navigation from "../components/Navigation.vue";

export default {
  props: {
    projectSlug: true,
    lang: true,
  },

  mixins: [globalMixin, scrollMixin, pageArrowMixin],

  components: {
    Navigation,
  },

  data() {
    return {
      project: false,
      nextProject: false,
      isOnTop: true,
      scrollHeaderVisible: false,
    };
  },

  methods: {
    setProject(data) {
      this.project = data.project;
      this.nextProject = data.nextProject;
    },

    onChangeProject(projectSlug) {
      this.onStartLoading(() => {
        this.$router.push({ name: "project", params: { projectSlug } });
      });
    },

    setPageTitle() {
      document.title = this.project.title + ' | ' + process.env.VUE_APP_TITLE;
    },
  },

  mounted() {
    this.baseTitle = document.title;

    this.$http
      .get(this.getApiURL(`getProject/${this.projectSlug}?lang=${this.lang}`))
      .then((response) => {
        this.setProject(response.data);
        this.setPageTitle();
      });
    setTimeout(() => {
      this.$store.commit("setNavigationColor", "white");
      this.$store.commit("setLogoColor", "white");
    })
  },

  destroyed() {
    document.title = process.env.VUE_APP_TITLE;
  },

  watch: {
    projectSlug() {
      this.$http
        .get(this.getApiURL(`getProject/${this.projectSlug}?lang=${this.lang}`))
        .then((response) => {
          this.setProject(response.data);
          this.setPageTitle();
          this.onPageLoaded();
          setTimeout(() => {
            this.handleScroll();
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "../assets/vars.scss";

/* Project */

.project {}

.project__text-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  position: relative;
  margin-top: 120px;
  gap: 20px;

  @media #{$mb} {
    grid-template-columns: 1fr;
    margin-top: 50px;
    max-width: 100vw;
  }

  &.grey__block {
    padding-top: 100px;

    @media #{$mb} {
      padding-top: 30px;
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: -20px;
      background: #303030;
      width: 92px;
      height: 18px;

      @media #{$mb} {
        width: 41px;
        height: 8px;
      }
    }
  }

  div {
    width: 100%;

    &:nth-child(1) {
      font-family: 'Didot';
      font-style: normal;
      font-weight: 400;
      font-size: 40px;
      line-height: 110%;
      letter-spacing: -0.02em;

      @media #{$mb} {
        width: 100%;
        min-width: unset;
      }
    }

    &:nth-child(2) {
      letter-spacing: -0.02em;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      letter-spacing: -0.02em;

      @media #{$mb} {
        width: 100%;
      }
    }
  }
}

.project__top {
  padding-top: rem(22px);
  background: white;

  @media #{$mb} {
    margin-top: 0;
    border-top: 0;
    padding-top: rem(22px);
  }
}

.project__title {
  font-family: "Didot";
  font-style: normal;
  font-weight: 400;
  font-size: 70px;
  line-height: 64px;

  @media #{$mb} {
    font-size: rem(36px);
    letter-spacing: 1.12px;
    line-height: rem(48px);
  }
}

.project__type {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 14px;
  letter-spacing: -0.02em;
  margin-bottom: 25px;

  @media #{$mb} {
    margin-bottom: 10px;
    font-size: 13px;
  }
}

.project-blocks {
  // margin-top: rem(80px);

  @media #{$mb} {
    // margin-top: rem(40px);
  }
}

.project-blocks__title {
  font-family: 'Didot';
  font-size: rem(40px);
  color: #303030;
  line-height: rem(36px);

  @media #{$mb} {
    font-size: rem(24px);
  }
}

.project-blocks__list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  max-width: 890px;
  gap: 20px;

  @media #{$mb} {
    margin-top: 7px;
    grid-template-columns: 1fr 1fr;

    &._mobile-rows {
      .project-blocks__item {
        width: 100%;
      }
    }
  }

  &._two-columns {
    width: 66.666%;

    @media #{$mb} {
      width: 100%;
    }

    .project-blocks__item {
      width: 100%;
    }
  }
}

.project-blocks__item {
  margin-top: rem(40px);
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;

  @media #{$mb} {
    padding-right: rem(20px);
    margin-top: rem(20px);
  }

  &._link {
    position: relative;

    &:before {
      content: "";
      position: absolute;
      margin-right: 17px;
      top: 5px;
      right: 100%;
      display: block;
      width: 12px;
      height: 12px;
      background: url(/images/external.svg) center / contain no-repeat;

      @media #{$mb} {
        margin-right: 5px;
        width: 8px;
        height: 8px;
        top: 6px;
      }
    }
  }
}

.project-blocks__block-title {
  font-size: 14px;
  font-weight: 500;
  color: #303030;
  line-height: 14px;
}

.project-blocks__block-desc {
  color: #303030;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-top: 6px;
  letter-spacing: -0.03em;
  padding-right: 30px;

  @media #{$mb} {
    margin-top: 4px;
  }
}

.project-blocks__block-name {
  font-weight: 500;
  font-size: rem(18px);
  color: #303030;
  letter-spacing: 0.38px;
  line-height: rem(24px);

  @media #{$mb} {
    font-size: rem(14px);
    letter-spacing: 0.29px;
    line-height: rem(20px);
  }
}

.project-blocks__block-value {
  font-size: rem(12px);
  color: #8d8d8d;
  letter-spacing: 0.33px;
  line-height: rem(14px);
  margin-top: rem(6px);

  @media #{$mb} {
    font-size: rem(10px);
    letter-spacing: 0.28px;
    line-height: rem(14px);
    margin-top: rem(4px);
  }
}

.project__body {
  padding-top: rem(60px);
  background: white;

  @media #{$mb} {
    padding-top: rem(62px);
  }
}

.project__top-description {
  font-family: "Didot";
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 110%;
  letter-spacing: -0.02em;
  color: #303030;
}

.project__about-title {
  font-weight: 700;
  font-size: rem(30px);
  color: #303030;
  letter-spacing: 0.83px;
  line-height: rem(36px);
  margin-top: rem(73px);

  &._big-margin {
    margin-top: rem(100px);

    @media #{$mb} {
      margin-top: rem(40px);
    }
  }

  @media #{$mb} {
    margin-top: rem(31px);
  }
}

.project__text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  margin-top: rem(40px);

  @media #{$mb} {
    margin-top: rem(20px);
  }
}

.project__image {
  margin-top: 120px;
  box-sizing: border-box;

  @media #{$mb} {
    margin-top: rem(31px);
  }

  img {
    display: block;
    width: 100%;
  }

  &+.project__image {
    margin-top: 80px;

    @media #{$mb} {
      margin-top: rem(20px) !important;
    }
  }

  &.--placement-left,
  &.--placement-left-margin,
  &.--placement-right,
  &.--placement-right-margin {
    display: flex;
    width: 100%;
    justify-content: flex-start;

    @media #{$mb} {
      flex-direction: column;
    }

    img {
      width: 66.66%;
      object-fit: cover;

      @media #{$mb} {
        margin: auto;
        width: 90%;
      }
    }

    .project__image-label {
      flex: 1;

      @media #{$dt} {
        margin-top: 0;
      }

      @media #{$mb} {
        width: 100%;
      }
    }
  }

  &.--placement-left,
  &.--placement-left-margin {
    @media #{$mb} {
      align-items: flex-start;
    }

    .project__image-label {
      .wrapper {
        @media #{$dt} {
          padding: rem(40px);
        }
      }
    }
  }

  &.--placement-left-margin {
    padding-left: rem(60px);

    @media #{$mb} {
      padding-left: 0;
    }

    .project__image-label {
      .wrapper {
        @media #{$dt} {
          padding: rem(40px);
        }
      }
    }
  }

  &.--placement-right,
  &.--placement-right-margin {
    flex-direction: row-reverse;

    @media #{$mb} {
      flex-direction: column;
      align-items: flex-end;
    }
  }

  &.--placement-right {
    .project__image-label {
      .wrapper {
        @media #{$dt} {
          padding: rem(40px 40px 40px 120px);
        }
      }
    }
  }

  &.--placement-right-margin {
    padding-right: rem(60px);

    @media #{$mb} {
      padding-right: 0;
    }

    .project__image-label {
      .wrapper {
        @media #{$dt} {
          padding: rem(40px 40px 40px 60px);
        }
      }
    }
  }
}

.project__image-label {
  margin-top: rem(21px);
  font-family: 'Graphik LCG';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.02em;
  color: #303030;
}

.project__text-big {
  font-size: rem(20px);
  color: #303030;
  letter-spacing: 0.42px;
  line-height: rem(32px);

  @media #{$mb} {
    font-size: rem(18px);
    line-height: rem(35px);
  }
}


.project__bottom {
  padding-bottom: rem(100px);
  padding-top: 3.25rem;
  background: white;

  @media #{$mb} {
    padding-top: 1.3rem;
    padding-bottom: rem(40px);
  }
}

.project__bottom-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media #{$mb} {
    display: block;
  }

  .project-blocks {
    width: 48%;

    @media #{$mb} {
      width: 100%;
    }
  }

  .project-blocks__item {
    width: 100%;

    @media #{$mb} {
      width: 100%;
    }
  }
}

.project__next {
  position: relative;
  display: block;
  height: rem(180px);
  color: #303030;
  text-decoration: none;
  border-top: 1px solid #e6e6e6;
  transition: all 0.5s ease;
  background: white;

  @media #{$mb} {
    height: auto;
    padding-bottom: rem(56px);
  }

  &:hover {
    color: #fff;

    .project__next-image {
      opacity: 1;
    }

    .project__next-title__svg {
      stroke: #fff;
    }
  }
}

.project__next-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: all 0.5s ease;

  background: {
    size: cover;
    position: center;
  }
}

.project__next-content {
  position: relative;
  z-index: 2;
  padding-top: rem(58px);

  @media #{$mb} {
    padding-top: rem(40px);
  }
}

.project__next-label {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.02em;
  color: inherit;
}

.project__next-title {
  font-family: 'Didot';
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 110%;
  letter-spacing: -0.02em;
  margin-top: 13px;

  @media #{$mb} {
    position: relative;
    margin-top: rem(4px);
    padding-right: rem(15px);
  }
}

.project__next-title__icon {
  display: inline-block;
  vertical-align: middle;
  margin-left: rem(70px);

  @media #{$mb} {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.project__next-title__svg {
  stroke: #000;
  transition: all 0.5s ease;
}

/* partners */

.index-screen__partners-title {
  font-weight: 700;
  font-size: 18px;
}

.index-screen__partners {
  padding-top: rem(40px);
  font-size: 0;
  margin: 0 0 0 rem(-59px);
  text-align: center;

  @media #{$mb} {
    margin: 0;
  }
}

.index-screen__partners__item {
  display: inline-block;
  vertical-align: middle;
  margin: rem(40px 59px 0);
  transition: all 0.4s ease;

  &:hover {
    opacity: 0.6;
  }

  @media #{$mb} {
    vertical-align: middle;
    margin: rem(20px 15px 0);
  }

  img {
    display: block;
    width: 100%;
  }

  &._n1 {
    width: rem(129px);

    @media #{$mb} {
      width: 90px;
    }
  }

  &._n2 {
    width: rem(106px);

    @media #{$mb} {
      width: 75px;
    }
  }

  &._n3 {
    width: rem(130px);

    @media #{$mb} {
      width: 91px;
    }
  }

  &._n4 {
    width: rem(158px);

    @media #{$mb} {
      width: 110px;
    }
  }

  &._fedex {
    width: rem(120px);

    @media #{$mb} {
      width: 81px;
    }
  }

  &._gazprom {
    width: rem(100px);

    @media #{$mb} {
      width: rem(60px);
    }
  }

  &._lukoil {
    width: rem(126px);

    @media #{$mb} {
      width: rem(80px);
    }
  }

  &._alphabank {
    width: rem(143px);
    margin-bottom: rem(-13px);

    @media #{$mb} {
      width: rem(64px);
      margin-bottom: 0;
    }
  }
}

.project__top-info {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.02em;
  max-width: 315px;
}

.project__body__top {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 120px;
  position: relative;

  @media #{$mb} {
    margin-top: 50px;
    padding-top: 30px;
    align-items: flex-start;
  }

  &.grey__block {
    &::after {
      content: "";
      position: absolute;
      width: 92px;
      height: 18px;
      background: #303030;
      left: 0;
      top: 0;

      @media #{$mb} {
        width: 41px;
        height: 8px;
      }
    }
  }

  .top__right {
    max-width: calc(50% - 20px);
    flex-direction: column;

    @media #{$mb} {
      max-width: unset;
    }
  }

  .project__top__text {
    margin-top: 30px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: -0.02em;
  }
}

.project__images-block {
  margin: 120px 0;
  display: flex;
  position: relative;

  .project__images-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 19px;
    padding-left: 60px;
    padding-right: 60px;
    width: calc((427px * 2) + 140px);
    box-sizing: border-box;

    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
    }

    @media #{$mb} {
      width: 90%;
      margin: 0 auto;
      padding-left: 0;
      padding-right: 0;
    }

    @media (min-width: 1441px) {
      width: calc(66.6% + 35px);
    }
  }

  &.--placement-right {
    justify-content: flex-end;
  }

  &.--placement-center {
    .project__images-wrapper {
      width: auto;
    }
  }

  @media #{$mb} {
    margin: 20px 0;
  }
}
</style>
